import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'curency',
  pure: false
})
export class CurencyPipe implements PipeTransform {

  public currencyDetail : any;

  transform(productPrice: any){

    
    this.currencyDetail = localStorage.getItem('currency');
    this.currencyDetail = JSON.parse(this.currencyDetail);

    
    return this.currencyDetail.symbolLeft + (productPrice).toFixed(this.currencyDetail.decimalPlaces) + this.currencyDetail.symbolRight;
    
  }
}
